import useRecoveryCodeVerifyBlock from '$actions/useRecoveryCodeVerifyForm'
import {
  description as descriptionStyle,
  header,
  title as titleStyle
} from '$blocks/common/auth.css'
import RecoveryCodeVerifyForm from '$hook-forms/RecoveryCodeVerifyForm'
import { FC } from 'react'

export type RecoveryCodeVerifyBlockProps = ReturnType<
  typeof useRecoveryCodeVerifyBlock
>

export const RecoveryCodeVerifyBlock: FC<RecoveryCodeVerifyBlockProps> = ({
  title,
  description,
  ...props
}) => {
  return (
    <>
      <header className={header}>
        <h2 className={titleStyle}>{title}</h2>

        <p className={descriptionStyle}>{description}</p>
      </header>

      <RecoveryCodeVerifyForm {...props} />
    </>
  )
}

export default RecoveryCodeVerifyBlock
